
import Dropdown from '~/components/header/Dropdown.vue';
import Flag from '~/components/icons/Flag.vue';
import IconCaretRight from '~/components/icons/IconCaretRight.vue';

export default {
  filters: {
    uppercase: (value) => value.toUpperCase(),
  },

  components: {
    Dropdown,
    Flag,
    IconCaretRight,
  },

  computed: {
    languages() {
      return this.$store.state.languages.sort((a, b) => (a.native_name > b.native_name ? 1 : -1));
    },
    language() {
      return this.$store.state.language;
    },
  },
  methods: {
    handleToggle(expanded) {
      this.$emit('toggled', expanded);
    },
  },
};
